import { jsxs as n, jsx as r, Fragment as q } from "react/jsx-runtime";
import { forwardRef as J, useState as Q, useRef as O, useEffect as E } from "react";
import { c as X } from "./bind-6db9bd07.mjs";
import "./components/AlertMessage/AlertMessage.js";
import "./components/Breadcrumb/Breadcrumb.js";
import "./components/Breakpoint/BreakpointProvider.js";
import "./components/BrowserMessage/BrowserMessage.js";
import "./components/Button/Button.js";
import "./components/Carousel/Carousel.js";
import "./components/Checkbox/Checkbox.js";
import "./components/Checkbox/CardCheckbox/CardCheckbox.js";
import "./components/ContentSlot/ContentSlot.js";
import "./components/DatePicker/DatePicker.js";
import "./components/Drawer/Drawer.js";
import "./DropDown-e20f1bba.mjs";
import "./components/FeatureFlag/FeatureFlagProvider.js";
import "./components/GenericLink/GenericLink.js";
import "./components/IconButton/IconButton.js";
import v from "./components/Icons/Icons.js";
import "./components/Input/Input.js";
import "./components/Loader/Loader.js";
import "./components/MasterData/MasterDataProvider.js";
import "./components/Menu/Menu.js";
import "./components/Modal/Modal.js";
import "./components/Config/ConfigProvider.js";
import "./components/NextgenImage/NextgenImageProvider.js";
import "./components/Notification/Notification/Notification.js";
import "./components/NotificationBar/NotificationBar.js";
import "./components/Notification/Bubble/BubbleNotification.js";
import "./components/PhoneNumber/PhoneNumber.js";
import "./components/Pill/Pill.js";
import "./components/PreviewPanel/PreviewPanel.js";
import "react-avatar-editor";
import "./components/PromotionalBanner/PromotionalBanner.js";
import "./components/QuantityStepper/QuantityStepper.js";
import "./components/RadioButton/RadioButton.js";
import "./components/RadioButton/CardRadio/CardRadioButton.js";
import "./components/Search/Search.js";
import "./components/Session/SessionProvider.js";
import "./components/SkeletonFrame/SkeletonFrame.js";
import "./components/SmartInput/SmartInput.js";
import "./Table-38f2ccde.mjs";
import "./components/Tabs/Tabs.js";
import "./components/Tag/Tag.js";
import "./TextArea-4fe2f782.mjs";
import "./components/TextLink/TextLink.js";
import "./components/Toast/ToastProvider.js";
import "./components/Toggle/Toggle.js";
import "./components/ProfileSection/ProfileSection.js";
import Z from "./components/Tooltip/Tooltip.js";
import "./components/Translation/TranslationProvider.js";
import "./components/Video/Video.js";
import "./components/Stepper/Stepper.js";
import "./ProgressTracker-032dff0d.mjs";
import "./components/NextgenRouter/NextgenRouter.js";
import "./components/DataVisualization/DoughnutChart/Doughnut.js";
import "./BaseChart.module-a61f9e4b.mjs";
import "./components/DataVisualization/BaseChart.js";
import "./components/Tealium/registries/userProfileRegistry.js";
import "@nextgen-web-framework/core";
import "@brightcove/react-player-loader";
import "./propTypes-cb2fba4b.mjs";
import "./components/ApiConfig/ApiConfigProvider.js";
import "./components/Preference/PreferenceProvider.js";
import "./components/SocialMediaIcon/SocialMediaIcon.js";
import "./components/ImageEditor/ImageEditor.js";
import "./Slider.module-4a946f4d.mjs";
import "./components/VariantSelector/VariantSelector.js";
import "./components/RichTextEditor/RichTextEditor.js";
import "isomorphic-dompurify";
import "./components/ImageWithOptionalCTA/ImageWithOptionalCTA.js";
import "./components/TextOnly/TextOnly.js";
import "./components/AudioPlayer/AudioPlayer.js";
import "./components/ImageAndText/ImageAndText.js";
import "./GridViewImageGallery.module-18c4d396.mjs";
import { filterIconTheme as oo } from "./components/utils/ThemeFilter/ThemeFilter.js";
import { ControlIconType as S, FontSize as to, AccordionStatus as T, AccordionStyle as c, KeyConstants as N, BorderDesign as ro } from "./components/Accordion/types/enums.js";
import { TooltipPreference as eo } from "./components/Tooltip/types/enums.js";
import { IconStyle as w } from "./components/Icons/types/enums.js";
import './assets/Accordion.css';const ao = "#ffffff", io = "#396e75", no = "#e5fdff", co = "#546223", lo = "#f0fae5", so = "#a65523", po = "#fff1e8", mo = "#7f3e3e", _o = "#ffe2e2", fo = "#62625a", wo = "#f8f8e7", go = "#38539a", zo = "#707070", uo = "#c8f8d1", bo = "#87c9c8", Co = "#5291b1", ho = "rgba(82, 145, 177, 0.1019607843)", Vo = "#445685", ko = "#181d61", $o = "rgba(24, 29, 97, 0.1019607843)", yo = "#5969d6", Bo = "#ea999d", Oo = "#b6577e", Eo = "rgba(182, 87, 126, 0.1019607843)", vo = "#7e3e80", No = "#1e247f", Ro = "rgba(30, 36, 127, 0.1019607843)", So = "#da7600", To = "#107f47", Po = "#d91734", Go = "_html_jtgz0_75", Hr = {
  amwayWhite: ao,
  darkBlue: io,
  lightBlue: no,
  darkGreen: co,
  lightGreen: lo,
  darkOrange: so,
  lightOrange: po,
  darkRed: mo,
  lightRed: _o,
  darkYellow: fo,
  lightYellow: wo,
  darkPurple: go,
  darkGrayOnWhite: zo,
  dataVizColor1: uo,
  dataVizColor2: bo,
  dataVizColor3: Co,
  dataVizColor3Background: ho,
  dataVizColor4: Vo,
  dataVizColor5: ko,
  dataVizColor5Background: $o,
  dataVizColor6: yo,
  dataVizColor7: Bo,
  dataVizColor8: Oo,
  dataVizColor8Background: Eo,
  dataVizColor9: vo,
  dataVizColor10: No,
  dataVizColor10Background: Ro,
  dataVizAlertOrange: So,
  dataVizSuccessGreen: To,
  dataVizWarningRed: Po,
  "no-visible": "_no-visible_jtgz0_34",
  html: Go,
  "footer-drawer": "_footer-drawer_jtgz0_142",
  "footer-drawer-section": "_footer-drawer-section_jtgz0_148",
  "footer-input-upload": "_footer-input-upload_jtgz0_157",
  "profile-banner-drawer": "_profile-banner-drawer_jtgz0_161",
  "profile-avatar-wrapper": "_profile-avatar-wrapper_jtgz0_165",
  "profile-avatar-row": "_profile-avatar-row_jtgz0_171",
  "profile-content": "_profile-content_jtgz0_176",
  "profile-rotate": "_profile-rotate_jtgz0_184",
  "profile-divider": "_profile-divider_jtgz0_193",
  "profile-remove-image": "_profile-remove-image_jtgz0_199",
  "profile-rotate-container": "_profile-rotate-container_jtgz0_208",
  "profile-error-state": "_profile-error-state_jtgz0_216"
}, Ao = "#ffffff", jo = "#396e75", Io = "#e5fdff", Do = "#546223", Wo = "#f0fae5", Lo = "#a65523", Yo = "#fff1e8", xo = "#7f3e3e", Fo = "#ffe2e2", Ko = "#62625a", Ho = "#f8f8e7", Mo = "#38539a", Uo = "#707070", qo = "#c8f8d1", Jo = "#87c9c8", Qo = "#5291b1", Xo = "rgba(82, 145, 177, 0.1019607843)", Zo = "#445685", ot = "#181d61", tt = "rgba(24, 29, 97, 0.1019607843)", rt = "#5969d6", et = "#ea999d", at = "#b6577e", it = "rgba(182, 87, 126, 0.1019607843)", nt = "#7e3e80", ct = "#1e247f", lt = "rgba(30, 36, 127, 0.1019607843)", dt = "#da7600", st = "#107f47", pt = "#d91734", mt = "_html_ps7ww_75", _t = "_small_ps7ww_291", ft = "_medium_ps7ww_297", wt = "_icon_ps7ww_311", gt = "_collapse_ps7ww_325", zt = "_show_ps7ww_349", o = {
  amwayWhite: Ao,
  darkBlue: jo,
  lightBlue: Io,
  darkGreen: Do,
  lightGreen: Wo,
  darkOrange: Lo,
  lightOrange: Yo,
  darkRed: xo,
  lightRed: Fo,
  darkYellow: Ko,
  lightYellow: Ho,
  darkPurple: Mo,
  darkGrayOnWhite: Uo,
  dataVizColor1: qo,
  dataVizColor2: Jo,
  dataVizColor3: Qo,
  dataVizColor3Background: Xo,
  dataVizColor4: Zo,
  dataVizColor5: ot,
  dataVizColor5Background: tt,
  dataVizColor6: rt,
  dataVizColor7: et,
  dataVizColor8: at,
  dataVizColor8Background: it,
  dataVizColor9: nt,
  dataVizColor10: ct,
  dataVizColor10Background: lt,
  dataVizAlertOrange: dt,
  dataVizSuccessGreen: st,
  dataVizWarningRed: pt,
  "no-visible": "_no-visible_ps7ww_34",
  html: mt,
  "accordion-item": "_accordion-item_ps7ww_214",
  "accordion-header": "_accordion-header_ps7ww_217",
  "accordion-button": "_accordion-button_ps7ww_221",
  "button-stepped-open": "_button-stepped-open_ps7ww_237",
  "accordion-label-continer": "_accordion-label-continer_ps7ww_241",
  "accordion-label-main": "_accordion-label-main_ps7ww_252",
  "accordion-label-left": "_accordion-label-left_ps7ww_262",
  "complete-step": "_complete-step_ps7ww_271",
  "incomplete-step": "_incomplete-step_ps7ww_272",
  "accordion-label-body": "_accordion-label-body_ps7ww_284",
  "accordion-label": "_accordion-label_ps7ww_241",
  small: _t,
  medium: ft,
  "accordion-label-stepped-body": "_accordion-label-stepped-body_ps7ww_303",
  icon: wt,
  "icon-info": "_icon-info_ps7ww_319",
  collapse: gt,
  "accordion-body": "_accordion-body_ps7ww_333",
  "content-title": "_content-title_ps7ww_343",
  show: zt,
  "scale-in-content": "_scale-in-content_ps7ww_1",
  "close-content": "_close-content_ps7ww_353",
  "scale-out-content": "_scale-out-content_ps7ww_1",
  "icon-right": "_icon-right_ps7ww_357",
  "card-accordion": "_card-accordion_ps7ww_364",
  "top-border": "_top-border_ps7ww_374",
  "bottom-border": "_bottom-border_ps7ww_374",
  "top-bottom-border": "_top-bottom-border_ps7ww_374"
}, f = X.bind(o), ut = (a) => a === T.COMPLETE ? w.SOLID : w.REGULAR, R = ({ id: a, isAccordionOpen: i }) => {
  const t = document.getElementById(`${a}-collapse`);
  t && (t.style.overflow = i ? "initial" : "hidden");
}, bt = (a = !1, i) => i === S.CHEVRON ? "chevron-down" : a ? "minus" : "plus", Ct = J(
  (a, i) => {
    const {
      id: t,
      className: P = "",
      contentTitle: g = "",
      content: z = "",
      title: u,
      iconType: G = S.CHEVRON,
      borderDesign: b,
      children: A,
      accordionInfo: j = !1,
      accordionInfoText: I,
      onToggleCallback: s,
      isInCard: D = !0,
      isOpen: p,
      fontSize: W = to.LARGE,
      isBorderDesign: L = !0,
      labelInfo: Y,
      status: C = T.INCOMPLETE,
      accordionStyle: l = c.DEFAULT,
      steppedBody: h,
      ...V
    } = a, x = [N.ENTER, N.SPACE], [e, k] = Q(!1), F = O(null), m = O(), $ = (d) => {
      const B = !e;
      clearTimeout(m.current), k(B), s == null || s(d, B);
    }, K = (d) => {
      x.includes(d.code) && $(d);
    };
    E(() => {
      typeof p == "boolean" && k(p);
    }, [p]), E(() => {
      e ? m.current = setTimeout(() => {
        R({ id: t, isAccordionOpen: e });
      }, 300) : (clearTimeout(m.current), R({ id: t, isAccordionOpen: e }));
    }, [e]);
    const y = l !== c.STEPPED && (b || L), _ = f({
      [b || ro.TOP_BORDER]: y,
      "card-accordion": !y && D,
      "button-stepped-open": e && l === c.STEPPED
    }), H = ut(C), M = f("accordion-item", P, { show: e }, _), U = f(
      "collapse",
      { show: e, "close-content": !e },
      _
    );
    return /* @__PURE__ */ n("div", { className: M, id: t, role: "region", children: [
      /* @__PURE__ */ r("h2", { className: `${o["accordion-header"]}`, id: `${t}-accordion-header`, children: /* @__PURE__ */ r(
        "button",
        {
          id: `${t}-button`,
          className: `${o["accordion-button"]} ${_}`,
          "data-bs-toggle": "collapse",
          "data-bs-target": `${t}-collapse`,
          "data-testid": "accordion-test-id",
          "data-pod-name": "fwk",
          "aria-expanded": e,
          "aria-controls": `${t}-collapse`,
          ref: i,
          onClick: $,
          onKeyDown: K,
          ...V,
          children: /* @__PURE__ */ n("span", { className: o["accordion-label-continer"], children: [
            /* @__PURE__ */ n("div", { className: o["accordion-label-main"], children: [
              /* @__PURE__ */ n("div", { className: o["accordion-label-left"], children: [
                l === c.STEPPED && /* @__PURE__ */ r(v, { iconName: "circle-check", iconStyle: H, className: o[C] }),
                /* @__PURE__ */ r("span", { className: o["accordion-label-body"], children: /* @__PURE__ */ r("label", { className: `${o["accordion-label"]} ${o[W]}`, children: Y || u }) }),
                j && /* @__PURE__ */ r(
                  Z,
                  {
                    message: I || u,
                    preference: eo.LEFT,
                    className: o["icon-info"]
                  }
                )
              ] }),
              /* @__PURE__ */ r(
                v,
                {
                  theme: oo(V.theme),
                  iconName: bt(e, G),
                  iconStyle: w.SOLID,
                  className: `${o.icon} ${o["icon-right"]} `,
                  "data-testid": "accordion-icon-testid",
                  "data-pod-name": "fwk"
                }
              )
            ] }),
            l === c.STEPPED && h && /* @__PURE__ */ r("div", { className: o["accordion-label-stepped-body"], "data-testid": "accordion-step-body", "data-pod-name": "fwk", children: h })
          ] })
        }
      ) }),
      /* @__PURE__ */ r(
        "div",
        {
          id: `${t}-collapse`,
          className: U,
          "aria-label": `${t}-accordion-header`,
          "data-bs-parent": `#${t}`,
          ref: F,
          children: /* @__PURE__ */ r("div", { className: `${o["accordion-body"]}`, children: z && g ? /* @__PURE__ */ n(q, { children: [
            /* @__PURE__ */ r("div", { className: o["content-title"], children: g }),
            /* @__PURE__ */ r("div", { children: z })
          ] }) : A })
        }
      )
    ] });
  }
);
Ct.displayName = "Accordion";
export {
  Ct as A,
  Hr as s
};
//# sourceMappingURL=Accordion-57940442.mjs.map
